import { render } from "./Robot.vue?vue&type=template&id=571ba537&scoped=true"
import script from "./Robot.vue?vue&type=script&lang=js"
export * from "./Robot.vue?vue&type=script&lang=js"

import "./Robot.vue?vue&type=style&index=0&id=571ba537&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-571ba537"

export default script